import React from 'react'
import { HelpIcon, Image, Tag, TagProps, useMatchBreakpoints } from '@nominex/dex-uikit'
import { SlTooltip } from '@shoelace-style/shoelace/dist/react'
import { useTranslation } from 'contexts/Localization'

const ActiveTag: React.FC<TagProps> = (props) => {
  const { t } = useTranslation()
  return (
    <Tag variant="active" scale="xs" fontWeight="600" {...props}>
      {t('Active')}
    </Tag>
  )
}

const InactiveTag: React.FC<TagProps> = (props) => {
  const { t } = useTranslation()
  return (
    <Tag variant="textDisabled" scale="xs" fontWeight="600" {...props}>
      {t('Inactive')}
    </Tag>
  )
}

const HotTag: React.FC<TagProps> = (props) => {
  const { t } = useTranslation()
  return (
    <Tag
      startIcon={<Image src="/images/fire.png" height={12} width={12} />}
      variant="failure"
      scale="xs"
      fontWeight="600"
      {...props}
    >
      {t('Hot')}
    </Tag>
  )
}

const NewTag: React.FC<TagProps> = (props) => {
  const { t } = useTranslation()
  return (
    <Tag
      startIcon={<Image src="/images/thumbs-up.png" height={12} width={12} />}
      variant="primary"
      scale="xs"
      fontWeight="600"
      {...props}
    >
      {t('New')}
    </Tag>
  )
}

const LevelUpTag: React.FC<TagProps> = (props) => {
  const { t } = useTranslation()
  const { isDesktop } = useMatchBreakpoints()
  return (
    <SlTooltip
      content={t('Add liquidity to this farming pool to upgrade your farming level')}
      placement={isDesktop ? 'right' : 'top'}
      hoist
    >
      <Tag
        startIcon={<Image src="/images/rocket.png" height={12} width={12} />}
        variant="primary"
        scale="xs"
        fontWeight="600"
        {...props}
      >
        {t('Level up')}
        <HelpIcon height="12px" color="textSubtle" />
      </Tag>
    </SlTooltip>
  )
}

const SoonTag: React.FC<TagProps> = (props) => {
  const { t } = useTranslation()
  return (
    <Tag variant="lightBlue" scale="xs" fontWeight="600" {...props}>
      {t('Soon')}
    </Tag>
  )
}

export { ActiveTag, InactiveTag, HotTag, NewTag, LevelUpTag, SoonTag }
